import { useEffect } from 'react';

export const useMediaElementListener = (
  mediaElement: HTMLMediaElement | null,
  eventType: string,
  eventListener: EventListener,
) => {
  useEffect(() => {
    if (!mediaElement) {
      return;
    }

    mediaElement.addEventListener(eventType, eventListener);

    return () => {
      mediaElement.removeEventListener(eventType, eventListener);
    };
  }, [mediaElement, eventListener, eventType]);
};
